/**
 * Oceread 品牌 - Pay 页面配置
 */
import { commonTexts } from './common'
import type { PayPageConfig } from './types'

/**
 * Oceread 品牌特定主题配置
 * 注意: 大部分颜色应使用 UnoCSS 主题变量,这里只保留品牌特有的配置
 */
export const theme = {
  // 如需添加品牌特有样式配置，在此添加
} as const

export const resources = {
  goldCoinIcon: '/images/oceread/welfare-gold.png',
} as const

export const payConfig: PayPageConfig = {
  theme,
  texts: commonTexts,
  resources,
}
